import { PrestacionAgregada } from '../models/store.model';
import * as fromActions from '../actions/prestacion.action';

export const prestacionInitialState: PrestacionAgregada[] = [];

export function prestacionDataReducer(
    state = prestacionInitialState,
    action: fromActions.PrestacionDataActions
): PrestacionAgregada[] {

    switch (action.type) {

        case fromActions.SETPRESTACION:
            return [...state, action.prestacionAgregada];

        case fromActions.UPDATEPRESTACIONCANTIDAD:
            return state.map((item, index) =>
                index === action.updateCantidad.index
                    ? { ...item, cantidad: action.updateCantidad.cantidad }
                    : item
            );

        case fromActions.DELETEPRESTACION:
            return state.filter((_, index) => index !== action.index);

        case fromActions.UNSETPRESTACION:
            return prestacionInitialState;

        default:
            return state;
    }
}
